import React from "react";
import { RegistrationForm } from "./RegistrationForm";

export default React.memo(RegistrationForm);
